<template>
  <div>
    <material-card class="card-tabs" color="green">
      <v-flex slot="header">
        <v-tabs
          v-model="mainTab"
          @change="changeMainTab"
          color="transparent"
          slider-color="white"
        >
          <!-- <span
                        class="subheading font-weight-light mr-3"
                        style="align-self: center"
                        >Transactions:</span
                    > -->
          <v-tab class="mr-3" href="#payments" v-if="!hasLimitedView()">
            <v-icon class="mr-2">mdi-currency-usd</v-icon>
            Payments
          </v-tab>
          <v-tab class="mr-3" href="#communications" v-if="!hasLimitedView()">
            <v-icon class="mr-2">mdi-account-switch</v-icon>
            Communications
          </v-tab>
          <v-tab class="mr-3" href="#students">
            <v-icon class="mr-2">mdi-human-child</v-icon>
            Students
          </v-tab>
          <v-tab class="mr-3" href="#geo" v-if="showGeo()">
            <v-icon class="mr-2">mdi-map-marker-radius</v-icon>
            GEO
          </v-tab>
          <v-tab class="mr-3" href="#registation" v-if="!hasLimitedView()">
            <v-icon class="mr-2">mdi-account-edit</v-icon>
            Registation
          </v-tab>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!hasLimitedView()"
            style="color: #4caf50; background-color: #FFF"
            class="ma-0"
            @click="newPaymentDialog = true"
            >New Payment</v-btn
          >
        </v-tabs>
      </v-flex>

      <div v-if="['students', 'registation'].includes(mainTab)">
        <student-list
          v-if="mainTab == 'students'"
          :students="students"
        ></student-list>
      </div>

      <div v-if="mainTab == 'geo'">
        <account-geo-details
          :account="account"
          :geoInfo="geoInfo"
          :students="students"
        ></account-geo-details>
      </div>

      <div
        class="account-transactions-subtab"
        :class="{ 'communications-subtabs': mainTab == 'communications' }"
        v-if="
          ['communications', 'payments', 'registation', 'lapidus'].includes(
            mainTab
          )
        "
      >
        <v-tabs v-model="activeTab" icons-and-text hide-slider>
          <v-tabs-slider color="success"></v-tabs-slider>

          <div v-if="mainTab == 'payments'">
            <v-tab
              ref="processedTab"
              href="#processed"
              v-bind:class="{
                'selected-tab': this.activeTab == 'processed',
              }"
            >
              Payments
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'processed',
                }"
                >mdi-currency-usd</v-icon
              >
            </v-tab>

            <v-tab
              href="#scheduled"
              v-bind:class="{
                'selected-tab': this.activeTab == 'scheduled',
              }"
            >
              Schedules
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'scheduled',
                }"
                >mdi-clock-outline</v-icon
              >
            </v-tab>
            <v-tab
              href="#rewards"
              v-bind:class="{
                'selected-tab': this.activeTab == 'rewards',
              }"
            >
              Rewards
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'rewards',
                }"
                >mdi-cash</v-icon
              >
            </v-tab>
            <v-tab
              href="#pickup"
              v-bind:class="{
                'selected-tab': this.activeTab == 'pickup',
              }"
            >
              Payment Pickup
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'pickup',
                }"
                >mdi-cash-multiple</v-icon
              >
            </v-tab>
            <v-tab
              href="#coupons"
              v-bind:class="{
                'selected-tab': this.activeTab == 'coupons',
              }"
            >
              Coupons
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'coupons',
                }"
                >mdi-ticket-percent</v-icon
              >
            </v-tab>
          </div>
          <div v-if="mainTab == 'communications'" class="comm-subtab-group">
            <v-tab
              href="#messages"
              ref="messagesTab"
              v-bind:class="{
                'selected-tab': this.activeTab == 'messages',
              }"
            >
              {{ commTabLabel("SMS", "messages", smsMessagesCount) }}
              <span class="comm-tab-icon-wrap">
                <v-icon
                  v-bind:class="{
                    'selected-tab-icon': this.activeTab == 'messages',
                  }"
                  >mdi-message-processing</v-icon
                >
                <span v-if="pendingMessagesCount" class="comm-pending-count">
                  ({{ pendingMessagesCount }})
                </span>
              </span>
            </v-tab>
            <v-tab
              href="#callback"
              v-bind:class="{
                'selected-tab': this.activeTab == 'callback',
              }"
            >
              {{ commTabLabel("Callback", "callback", getCallbackCount()) }}
              <span class="comm-tab-icon-wrap">
                <v-icon
                  v-bind:class="{
                    'selected-tab-icon': this.activeTab == 'callback',
                  }"
                  >mdi-phone-return</v-icon
                >
                <span
                  v-if="getPendingCallbackRequestsCount()"
                  class="comm-pending-count"
                >
                  ({{ getPendingCallbackRequestsCount() }})
                </span>
              </span>
            </v-tab>
            <v-tab
              href="#emails"
              v-bind:class="{
                'selected-tab': this.activeTab == 'emails',
              }"
            >
              {{ commTabLabel("Emails", "emails", getEmailsCount()) }}
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'emails',
                }"
                >mdi-email</v-icon
              >
            </v-tab>
            <v-tab
              href="#faxes"
              v-bind:class="{
                'selected-tab': this.activeTab == 'faxes',
              }"
            >
              {{ commTabLabel("Faxes", "faxes", faxesCount) }}
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'faxes',
                }"
                >mdi-fax</v-icon
              >
            </v-tab>
            <v-tab
              href="#calls"
              v-bind:class="{
                'selected-tab': this.activeTab == 'calls',
              }"
            >
              {{
                commTabLabel("Broadcast Calls", "calls", broadcastCallsCount)
              }}
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'calls',
                }"
                >mdi-phone-in-talk</v-icon
              >
            </v-tab>
            <v-tab
              href="#sitevisits"
              v-bind:class="{
                'selected-tab': this.activeTab == 'sitevisits',
              }"
            >
              {{ commTabLabel("Site Visits", "sitevisits", siteVisitsCount) }}
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'sitevisits',
                }"
                >mdi-web</v-icon
              >
            </v-tab>
            <v-tab
              href="#ivrcalls"
              v-bind:class="{
                'selected-tab': this.activeTab == 'ivrcalls',
              }"
            >
              {{ commTabLabel("IVR Calls", "ivrcalls", ivrCallsCount) }}
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'ivrcalls',
                }"
                >mdi-phone</v-icon
              >
            </v-tab>
            <v-tab
              href="#contactus"
              v-bind:class="{
                'selected-tab': this.activeTab == 'contactus',
              }"
            >
              {{ commTabLabel("Contact Us", "contactus", getContactUsCount()) }}
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'contactus',
                }"
                >mdi-email</v-icon
              >
            </v-tab>
            <v-progress-linear
              v-if="anyCommCountLoading"
              :indeterminate="true"
              color="success"
              height="2"
              class="comm-tabs-loading"
            ></v-progress-linear>
          </div>
          <div v-if="mainTab == 'registation'">
            <v-tab
              href="#registation"
              v-bind:class="{
                'selected-tab': this.activeTab == 'registation',
              }"
            >
              Registation
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'registation',
                }"
                >mdi-account-edit</v-icon
              >
            </v-tab>
            <v-tab
              href="#vm"
              ref="messagesTab"
              v-bind:class="{
                'selected-tab': this.activeTab == 'vm',
              }"
            >
              VM
              <v-icon
                v-bind:class="{
                  'selected-tab-icon': this.activeTab == 'vm',
                }"
                >mdi-account-key</v-icon
              >
            </v-tab>
          </div>
          <v-card v-if="mainTab == 'lapidus'">
            <v-btn @click="openLapidusDialog" color="success"
              >Day Camp Charge</v-btn
            >
          </v-card>

          <v-tabs-items v-model="activeTab">
            <v-tab-item
              v-for="tab in getTabItems()"
              v-if="tab === activeTab"
              :key="tab"
              :value="tab"
            >
              <account-site-visits
                v-if="activeTab == 'sitevisits'"
                :siteVisits="siteVisits"
              ></account-site-visits>
              <account-ivr-calls
                v-if="activeTab == 'ivrcalls'"
                :ivrCalls="ivrCalls"
              ></account-ivr-calls>
              <account-broadcast-calls
                v-if="activeTab == 'calls'"
                @loaded="onBroadcastCallsLoaded"
              ></account-broadcast-calls>
              <account-faxes
                v-if="activeTab == 'faxes'"
                @loaded="onFaxesLoaded"
              ></account-faxes>

              <registation
                v-if="activeTab == 'registation'"
                ref="registation"
                :registrationRequirments="registrationRequirments"
                :account="account"
                :students="students"
                @application-info-saved="
                  $emit('application-info-saved', $event)
                "
              ></registation>

              <vm v-if="activeTab == 'vm'" :account="account"></vm>

              <v-card
                v-if="
                  ['processed', 'scheduled'].includes(activeTab) &&
                    !getTabList().length
                "
              >
                <v-card-text
                  class="text-xs-center"
                  v-text="emptyCardText()"
                ></v-card-text>
              </v-card>

              <v-expansion-panel
                class="expansion-panel-margin"
                v-model="expandedPayment"
                v-if="activeTab == 'processed'"
              >
                <v-expansion-panel-content v-for="payment in paymentsToDisplay">
                  <template v-slot:header>
                    <v-flex xs3>
                      <v-layout row align-start class="pa-0 mx-0">
                        <v-layout column class="py-0 ma-0">
                          <v-flex xs3>
                            <v-layout row>
                              <v-icon
                                class="mr-3 ml-1"
                                dark
                                :color="getStatusIconColor(payment)"
                                >{{ getStatusIcon(payment) }}</v-icon
                              >
                              <div>
                                <div class="subheading mb-1">
                                  {{ getPaymentDate(payment) }}
                                </div>
                                <div class="text--disabled subheading">
                                  {{ getPaymentStatus(payment) }}
                                </div>
                              </div>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2>
                      <div class="body-2 font-weight-medium mb-1">
                        Source:
                      </div>
                      <div class="body-2 mb-1">
                        {{ payment.source }}
                      </div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3>
                      <v-layout column align-end class="mx-0 pr-4">
                        <div
                          class="subheading mb-1"
                          v-bind:class="{
                            'text-danger': payment.amount < 0,
                          }"
                        >
                          {{ formatCurrency(payment.amount) }}
                        </div>
                        <div class="text--disabled subheading">
                          {{ payment.paymentType }}
                        </div>
                      </v-layout>
                    </v-flex>
                  </template>
                  <v-card>
                    <v-flex xs12>
                      <v-card-text class="subheading mt-2">
                        <v-layout row class="px-3 py-2">
                          <div class="font-weight-medium mr-2 width-200">
                            Date:
                          </div>
                          <div>
                            {{ formatTime(payment.date) }}
                          </div>
                        </v-layout>
                        <v-layout row class="px-3 py-2">
                          <div class="font-weight-medium mr-2 width-200">
                            Amount:
                          </div>
                          <div>
                            {{ formatCurrency(payment.amount) }}
                          </div>
                        </v-layout>
                        <v-layout
                          row
                          class="px-3 py-2"
                          v-for="prop in getPaymentProperties(payment)"
                        >
                          <div class="font-weight-medium mr-2 width-200">
                            {{ prop.name }}:
                          </div>
                          <div>
                            {{ prop.value }}
                          </div>
                        </v-layout>
                        <v-layout
                          v-if="payment.status == 'ERROR'"
                          row
                          class="px-3 py-2"
                        >
                          <div class="font-weight-medium mr-2 width-200">
                            Error Message:
                          </div>
                          <div class="text-danger">
                            {{ payment.transactionResult }}
                          </div>
                        </v-layout>
                        <v-layout
                          v-if="payment.details"
                          class="px-3 py-2 mt-3"
                          column
                        >
                          <div class="font-weight-medium mr-2 mb-1">
                            Payment Details:
                          </div>
                          <div>
                            {{ getPaymentDetails(payment) }}
                          </div>
                        </v-layout>
                        <div v-if="payment.refunds" class="pl-1 mt-2">
                          <div class="font-weight-medium mb-2">
                            Refunds
                          </div>
                          <v-layout
                            row
                            class="pl-3"
                            v-for="detail in getRefundDetails(payment)"
                          >
                            <div class="font-weight-regular mr-2">
                              {{ detail.date }}:
                            </div>
                            <div class="text-danger">${{ detail.amount }}</div>
                          </v-layout>
                        </div>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-layout row class="mb-1 pr-2">
                          <v-spacer></v-spacer>
                          <div v-if="payment.scheduleDetailId">
                            <v-btn
                              small
                              outline
                              color="info"
                              class="mr-2"
                              v-on:click="viewSchedule(payment)"
                            >
                              View Schedule
                            </v-btn>
                          </div>
                          <v-btn
                            v-if="canReverse(payment)"
                            small
                            dark
                            class="mx-0"
                            color="default"
                            v-on:click="reversePayment(payment)"
                          >
                            Reverse Payment
                          </v-btn>
                        </v-layout>
                      </v-card-actions>
                    </v-flex>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-layout
                justify-center
                class="mt-3 mb-1"
                v-if="activeTab == 'processed'"
              >
                <v-pagination
                  v-model="paymentsPagination.page"
                  :length="paymentsPages"
                  :total-visible="5"
                  v-on:input="setPaymentsPagianation"
                ></v-pagination>
              </v-layout>

              <v-expansion-panel
                class="expansion-panel-margin"
                v-model="expandedSchedule"
                v-if="activeTab == 'scheduled'"
              >
                <v-expansion-panel-content
                  v-for="schedule in schedulesToDisplay"
                  @input="onExpended(schedule)"
                >
                  <template v-slot:header>
                    <v-flex xs5>
                      <v-layout row align-start class="pa-0 mx-0">
                        <v-layout column class="py-0 ma-0">
                          <v-flex xs2>
                            <v-layout row>
                              <v-icon
                                class="mr-3 ml-1"
                                dark
                                :color="getStatusIconColor(schedule)"
                                >{{ getStatusIcon(schedule) }}</v-icon
                              >
                              <div>
                                <div class="subheading mb-1">
                                  {{ getPaymentDate(schedule) }}
                                </div>
                                <div class="text--disabled subheading">
                                  {{ getPaymentStatus(schedule) }}
                                </div>
                              </div>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3>
                      <div class="body-2 font-weight-medium mb-1">
                        Created:
                      </div>
                      <div class="body-2 mb-1">
                        {{ schedule.dateCreated | time }}
                      </div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs2>
                      <div class="body-2 font-weight-medium mb-1">
                        Source:
                      </div>
                      <div class="body-2 mb-1">
                        {{ schedule.source }}
                      </div>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs3>
                      <v-layout column align-end class="mx-0 pr-4">
                        <div class="subheading mb-1">
                          {{ formatCurrency(schedule.amount) }}
                        </div>
                        <div class="text--disabled subheading">
                          {{ schedule.paymentType }}
                        </div>
                      </v-layout>
                    </v-flex>
                  </template>
                  <v-card>
                    <v-flex xs12>
                      <v-card-text class="subheading mt-2">
                        <v-layout row class="px-3 py-2">
                          <div class="font-weight-medium mr-2 width-200">
                            Amount:
                          </div>
                          <div>
                            {{ formatCurrency(schedule.amount) }}
                          </div>
                        </v-layout>
                        <v-layout row class="px-3 py-2">
                          <div class="font-weight-medium mr-2 width-200">
                            Amount Processed:
                          </div>
                          <div>
                            {{ formatCurrency(schedule.amountProcessed) }}
                          </div>
                        </v-layout>
                        <v-layout
                          row
                          class="px-3 py-2"
                          v-for="prop in getScheduleProperties(schedule)"
                        >
                          <div class="font-weight-medium mr-2 width-200">
                            {{ prop.name }}:
                          </div>
                          <div>
                            {{ prop.value }}
                          </div>
                        </v-layout>
                        <v-layout row class="px-3 py-2">
                          <div class="font-weight-medium mr-2 width-200">
                            Schedules Processed:
                          </div>
                          <div>
                            {{ schedule.processed }}
                          </div>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="mt-0"
                            v-if="allowEditingSchedule(schedule)"
                            @click="openEditScheduleDialog(schedule)"
                            small
                            dark
                            color="default"
                            >Edit/Cancel Schedule</v-btn
                          >
                        </v-layout>
                        <vue-good-table
                          v-if="schedule.scheduleDetails.length"
                          class="schedule-list"
                          styleClass="vgt-table striped"
                          :columns="scheduleDetailColumns"
                          :rows="schedule.scheduleDetails"
                          :search-options="{
                            enabled: false,
                          }"
                        >
                          <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.isIcon" class="px-0">
                              <v-icon
                                class="px-0"
                                dark
                                :color="
                                  props.column.iconColor(
                                    props.row[props.column.field]
                                  )
                                "
                                >{{
                                  props.column.icon(
                                    props.row[props.column.field]
                                  )
                                }}</v-icon
                              >
                            </span>
                            <span
                              v-else-if="
                                props.column.isAction &&
                                  props.column.showAction(props.row)
                              "
                              class="px-0"
                            >
                              <v-btn
                                small
                                flat
                                color="warning"
                                class="mt-0"
                                @click="props.column.action(props.row)"
                                >Reschedule</v-btn
                              >
                            </span>
                            <span v-else>
                              {{ props.formattedRow[props.column.field] }}
                            </span>
                          </template>
                        </vue-good-table>
                      </v-card-text>
                    </v-flex>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-layout
                justify-center
                class="mt-3 mb-1"
                v-if="activeTab == 'scheduled'"
              >
                <v-pagination
                  v-model="schedulePagination.page"
                  :length="schedulePages"
                  :total-visible="5"
                  v-on:input="setSchedulePagianation"
                ></v-pagination>
              </v-layout>

              <div v-if="activeTab == 'rewards'">
                <account-rewards
                  :accountID="account.accountID"
                  ref="accountRewards"
                >
                </account-rewards>
              </div>

              <div v-if="activeTab == 'pickup'">
                <account-pickups
                  :accountID="account.accountID"
                  :account="account"
                  :accountPhones="phonesNumbers"
                  ref="accountPickups"
                >
                </account-pickups>
              </div>
              <div
                v-if="activeTab == 'coupons' && tab == 'coupons'"
                class="px-2 py-2 coupon-types-container"
              >
                <v-layout row wrap>
                  <v-flex xs12 class="coupon-type-header-wrap">
                    <div class="coupon-type-header">
                      <div class="coupon-type-header-left">
                        <v-icon
                          small
                          class="mr-2 coupon-type-icon coupon-type-icon--disc"
                        >
                          mdi-credit-card
                        </v-icon>
                        <span class="coupon-type-title">
                          DiscCard Benefit
                        </span>
                      </div>
                      <span class="coupon-type-pill coupon-type-pill--disc">
                        DiscCard
                      </span>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <disc-card-benefits
                      :accountID="account.accountID"
                      :accountEmail="account.emailAddress"
                    >
                    </disc-card-benefits>
                  </v-flex>

                  <template v-if="showCampCouponsFirst">
                    <v-flex
                      xs12
                      class="coupon-type-header-wrap coupon-type-header-wrap--spaced"
                    >
                      <div class="coupon-type-header">
                        <div class="coupon-type-header-left">
                          <v-icon
                            small
                            class="mr-2 coupon-type-icon coupon-type-icon--camp"
                          >
                            mdi-ticket-confirmation-outline
                          </v-icon>
                          <span class="coupon-type-title">
                            Camp Coupons
                          </span>
                        </div>
                        <span class="coupon-type-pill coupon-type-pill--camp">
                          Camp
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <camp-coupons
                        :accountID="account.accountID"
                        :accountEmail="account.emailAddress"
                        @latest-coupon-date="setCampLatestCouponDate"
                        @coupon-deadline="setCampCouponDeadline"
                      >
                      </camp-coupons>
                    </v-flex>

                    <v-flex
                      xs12
                      class="coupon-type-header-wrap coupon-type-header-wrap--spaced"
                    >
                      <div class="coupon-type-header">
                        <div class="coupon-type-header-left">
                          <v-icon
                            small
                            class="mr-2 coupon-type-icon coupon-type-icon--matzo"
                          >
                            mdi-store
                          </v-icon>
                          <span class="coupon-type-title">
                            Matzo Coupons
                          </span>
                        </div>
                        <span class="coupon-type-pill coupon-type-pill--matzo">
                          Matzo
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <matzo-coupons
                        :accountID="account.accountID"
                        :accountEmail="account.emailAddress"
                        @latest-coupon-date="setMatzoLatestCouponDate"
                        @coupon-deadline="setMatzoCouponDeadline"
                      >
                      </matzo-coupons>
                    </v-flex>
                  </template>

                  <template v-else>
                    <v-flex
                      xs12
                      class="coupon-type-header-wrap coupon-type-header-wrap--spaced"
                    >
                      <div class="coupon-type-header">
                        <div class="coupon-type-header-left">
                          <v-icon
                            small
                            class="mr-2 coupon-type-icon coupon-type-icon--matzo"
                          >
                            mdi-store
                          </v-icon>
                          <span class="coupon-type-title">
                            Matzo Coupons
                          </span>
                        </div>
                        <span class="coupon-type-pill coupon-type-pill--matzo">
                          Matzo
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <matzo-coupons
                        :accountID="account.accountID"
                        :accountEmail="account.emailAddress"
                        @latest-coupon-date="setMatzoLatestCouponDate"
                        @coupon-deadline="setMatzoCouponDeadline"
                      >
                      </matzo-coupons>
                    </v-flex>

                    <v-flex
                      xs12
                      class="coupon-type-header-wrap coupon-type-header-wrap--spaced"
                    >
                      <div class="coupon-type-header">
                        <div class="coupon-type-header-left">
                          <v-icon
                            small
                            class="mr-2 coupon-type-icon coupon-type-icon--camp"
                          >
                            mdi-ticket-confirmation-outline
                          </v-icon>
                          <span class="coupon-type-title">
                            Camp Coupons
                          </span>
                        </div>
                        <span class="coupon-type-pill coupon-type-pill--camp">
                          Camp
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <camp-coupons
                        :accountID="account.accountID"
                        :accountEmail="account.emailAddress"
                        @latest-coupon-date="setCampLatestCouponDate"
                        @coupon-deadline="setCampCouponDeadline"
                      >
                      </camp-coupons>
                    </v-flex>
                  </template>
                </v-layout>
              </div>

              <div v-if="activeTab == 'messages'">
                <account-sms-messages
                  :accountID="account.accountID"
                  :goToMessageSection="goToMessageSection"
                  :name="account.name"
                  ref="accountSmsMessages"
                  :firebaseRef="firebaseRef"
                >
                </account-sms-messages>
              </div>
              <div v-if="activeTab == 'callback'">
                <account-callback-requests
                  :accountID="account.accountID"
                  :goToCallbackSection="goToCallbackSection"
                  :name="account.name"
                  :callbackRequests="callbackRequests"
                  :loadCallbackRequests="loadCallbackRequests"
                  ref="accountCallbackRequests"
                >
                </account-callback-requests>
              </div>
              <div v-if="activeTab == 'contactus'">
                <account-contact-us-requests
                  :contactUsRequests="contactUsRequests"
                >
                </account-contact-us-requests>
              </div>
              <div v-if="activeTab == 'emails'">
                <account-emails @loaded="onEmailsLoaded"></account-emails>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
    </material-card>
    <v-layout row justify-center>
      <v-dialog scrollable v-model="editScheduleDialog" max-width="700">
        <edit-schedule
          :schedule="scheduleToEdit"
          :originalSchedule="originalSchedule"
          :closeDialog="closeEditScheduleDialog"
          :scheduleDetailColumns="scheduleDetailColumns"
          :paymentMethods="paymentMethods"
          :reloadPage="reloadPage"
          :accountID="account.accountID"
        ></edit-schedule>
      </v-dialog>
    </v-layout>
    <v-dialog persistent v-model="reversePaymentDialog" max-width="400">
      <reverse-payment
        :closeDialog="closeReversePaymentDialog"
        :payment="paymentToReverse"
        :reloadPage="reloadPage"
      ></reverse-payment>
    </v-dialog>
    <v-dialog v-model="newPaymentDialog" max-width="700" persistent>
      <new-payment
        ref="newPayment"
        :closeDialog="closeNewPaymentDialog"
        :paymentMethods="paymentMethods"
        :reloadPage="reloadPage"
        :account="account"
        :tuitionBalance="tuitionBalance"
        :transportationBalance="transportationBalance"
        :tkhBalance="tkhBalance"
      ></new-payment>
    </v-dialog>

    <v-dialog v-model="rescheduleDialog" max-width="400" persistent>
      <v-card class="pa-3">
        <v-card-title class="headline pa-0 mb-2"
          >Reschedule Payment</v-card-title
        >
        <div class="font-weight-medium pt-1">
          The payment of
          {{ paymentToReschedule.amount | currency }} will be rescheduled for
          {{ paymentToReschedule.scheduleDate | date }}
        </div>
        <v-card-actions class="mx-0 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            class="mr-1"
            @click="rescheduleDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="reschedule()">
            confirm
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
    <v-dialog v-model="lapidus.lapidusDialog" max-width="400" persistent>
      <v-card class="pa-3">
        <v-card-title class="headline pa-0 mb-2">Day Camp Charge</v-card-title>
        <v-text-field
          v-model="lapidus.bungalow"
          label="Bungalow"
          ref="lapidusBungalow"
          :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
          v-model="lapidus.quantity"
          type="number"
          label="Rooms"
          ref="lapidusQuantity"
          :rules="[rules.required]"
        ></v-text-field>
        <v-text-field
          v-model="lapidus.charge"
          type="number"
          label="Charge"
          ref="lapidusCharge"
          :rules="[rules.required]"
        ></v-text-field>
        <v-layout row justify-space-between>
          <div class="font-weight-medium">Total:</div>
          <div class="font-weight-medium">
            $ {{ (lapidus.quantity || 0) * (lapidus.charge || 0) }}
          </div>
        </v-layout>
        <v-card-actions class="mx-0 mt-3 pb-2">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            class="mr-1"
            @click="lapidus.lapidusDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="saveLapidusCharge()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { formatCurrency, toTitleCase, except } from "../../utils/helpers.js";
import editSchedule from "./EditScheduledPayments.vue";
import reversePayment from "./ReversePayment.vue";
import newPayment from "./NewPayment.vue";
import accountSmsMessages from "./AccountSmsMessages.vue";
import accountRewards from "./AccountRewards.vue";
import accountPickups from "./AccountPickups.vue";
import accountCallbackRequests from "./AccountCallbackRequests.vue";
import studentList from "./StudentList.vue";
import registation from "./Registation.vue";
import vm from "./Vm.vue";
import accountContactUsRequests from "./AccountContactUsRequests.vue";
import accountSiteVisits from "./AccountSiteVisits.vue";
import accountIvrCalls from "./AccountIvrCalls.vue";
import accountEmails from "./AccountEmails.vue";
import accountFaxes from "./AccountFaxes.vue";
import accountBroadcastCalls from "./AccountBroadcastCalls.vue";
import accountGeoDetails from "./AccountGeoDetails.vue";
import matzoCoupons from "./MatzoCoupons.vue";
import campCoupons from "./AccountCampCoupons.vue";
import discCardBenefits from "./DiscCardBenefits.vue";

import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";

export default {
  props: {
    transactionsLoaded: Boolean,
    allPayments: Array,
    payments: Array,
    schedules: Array,
    paymentMethods: Array,
    account: Object,
    reloadPage: Function,
    scheduleID: Number,
    tuitionBalance: String,
    transportationBalance: String,
    tkhBalance: String,
    goToMessageSection: Boolean,
    goToCallbackSection: Boolean,
    goToSiteVisitSection: Boolean,
    goToIvrCallSection: Boolean,
    goToEmailsSection: Boolean,
    goToFaxesSection: Boolean,
    goToCallsSection: Boolean,
    callbackRequests: Array,
    registrationRequirments: Array,
    contactUsRequests: Array,
    siteVisits: Array,
    ivrCalls: Array,
    contactUsLoaded: Boolean,
    callbackRequestsLoaded: Boolean,
    loadCallbackRequests: Function,
    students: Array,
    phonesNumbers: Array,
    geoInfo: Object,
  },
  components: {
    "edit-schedule": editSchedule,
    studentList,
    registation,
    accountContactUsRequests,
    reversePayment,
    newPayment,
    accountSmsMessages,
    accountRewards,
    accountPickups,
    accountCallbackRequests,
    accountSiteVisits,
    accountIvrCalls,
    accountEmails,
    accountFaxes,
    accountBroadcastCalls,
    accountGeoDetails,
    matzoCoupons,
    campCoupons,
    discCardBenefits,
    vm,
  },
  data() {
    return {
      activeTab: "processed",
      matzoLatestCouponDate: null,
      campLatestCouponDate: null,
      matzoCouponDeadline: null,
      campCouponDeadline: null,

      paymentToVoid: {},
      scheduleToEdit: {
        scheduleDetails: [],
      },

      originalSchedule: {
        scheduleDetails: [],
      },

      paymentToReverse: {
        details: [],
      },

      reversePaymentDialog: false,
      editScheduleDialog: false,
      processing: false,
      expandedSchedule: null,
      expandedPayment: null,
      limitedView: false,

      mainTab: "",

      paymentsToDisplay: [],

      paymentsPagination: {
        totalCount: 0,
        rowsPerPage: 5,
        page: 1,
      },

      schedulesToDisplay: [],

      schedulePagination: {
        totalCount: 0,
        rowsPerPage: 5,
        page: 1,
      },

      paymentToReschedule: {},
      rescheduleDialog: false,

      lapidus: {
        lapidusDialog: false,
        bungalow: "",
        quantity: 1,
        charge: 350,
        id: 0,
      },

      scheduleDetailColumns: [
        {
          sortable: true,
          field: "status",
          hidden: false,
          isIcon: true,
          icon: (value, row) => {
            if (!value) return "";

            if (value.toUpperCase().startsWith("ERROR"))
              return "mdi-alert-circle";

            switch (value.toUpperCase()) {
              case "APPROVED":
                return "mdi-check-circle";
              case "SCHEDULED":
                return "mdi-clock";
              case "DECLINED":
                return "mdi-alert";
              case "CANCELED":
                return "mdi-close-circle";
              default:
                return "";
            }
          },
          iconColor: (value, row) => {
            if (!value) return "";

            if (value.toUpperCase().startsWith("ERROR")) return "#f35123";

            switch (value.toUpperCase()) {
              case "APPROVED":
                return "success";
              case "SCHEDULED":
                return "#fdb400";
              case "DECLINED":
                return "#f35123";
              case "CANCELED":
                return "#aeb8bf";
              default:
                return "";
            }
          },
        },
        {
          field: "action",
          isAction: true,
          showAction: (row) => {
            return (
              row.status == "CANCELED" &&
              moment(row.scheduleDate).isAfter(moment())
            );
          },
          action: (row) => {
            this.openRescheduleDialog(row);
          },
        },
        {
          sortable: false,
          label: "Date",
          field: "scheduleDate",
          hidden: false,
          type: "date",
          width: "100px",
          dateOutputFormat: "MM/DD/YYYY",
        },
        {
          sortable: true,
          label: "Amount",
          field: "amount",
          type: "decimal",
          hidden: false,
          width: "100px",
          formatFn: (value) => formatCurrency(value),
        },
        {
          sortable: false,
          label: "Details",
          field: "details",
          hidden: false,
          width: "200px",
          formatFn: (value) => {
            if (!value) return "";

            const categories = new Map([
              ["TC", "Tuition"],
              ["TRNS", "Transportation"],
              ["LAPC", "Lapidus"],
            ]);

            return value
              .split("|")
              .map((detail) => {
                const category =
                  categories.get(detail.split(":")[0]) || detail.split(":")[0];
                const amount = detail.split(":")[1];

                return category + ": " + formatCurrency(amount);
              })
              .sort()
              .reverse()
              .join(" | ");
          },
        },
        {
          sortable: false,
          label: "Card",
          field: "cardInfo",
          width: "150px",
          hidden: false,
        },
        {
          sortable: true,
          label: "Status",
          field: "status",
          width: "100px",
          hidden: false,
        },
        {
          sortable: false,
          label: "Process Date",
          field: "processDate",
          type: "date",
          width: "215px",
          dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
          hidden: false,
        },
        {
          label: "Attempts",
          field: "attempts",
          type: "number",
          sortable: false,
          width: "150px",
          hidden: false,
        },
        {
          sortable: false,
          label: "Canceled By",
          field: "canceledBy",
          width: "150px",
          hidden: false,
        },
        {
          sortable: false,
          label: "Canceled At",
          field: "cancelDate",
          type: "date",
          width: "200px",
          dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
          hidden: false,
        },
        {
          sortable: false,
          label: "Updated By",
          field: "userUpdated",
          width: "150px",
          hidden: false,
        },
        {
          sortable: false,
          label: "Last Updated",
          field: "lastUpdated",
          type: "date",
          width: "215px",
          dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
          hidden: false,
        },
      ],

      categories: new Map([
        ["TC", "Tuition"],
        ["TRNS", "Transportation"],
        ["LAPC", "Lapidus"],
      ]),

      newPaymentDialog: false,

      firebaseRef: "",
      pendingMessagesCount: 0,
      smsMessagesCount: null,
      emailsCount: null,
      faxesCount: null,
      broadcastCallsCount: null,
      siteVisitsCount: null,
      ivrCallsCount: null,
      commCountsLoaded: {
        contactus: false,
        messages: false,
        callback: false,
        emails: false,
        faxes: false,
        calls: false,
        sitevisits: false,
        ivrcalls: false,
      },

      rules: {
        required: (value) => !!value || "Required",
      },
    };
  },
  watch: {
    scheduleID(newValue, oldValue) {
      if (newValue) {
        this.expandSchedule(newValue);
      }
    },
    account(newValue, oldValue) {
      if (newValue) {
        this.firebaseSetup();
        this.loadSmsMessagesCount();
        this.matzoLatestCouponDate = null;
        this.campLatestCouponDate = null;
        this.matzoCouponDeadline = null;
        this.campCouponDeadline = null;
      }

      const query = this.$route.query;

      if (this.$route.query.limitView) {
        this.limitedView = true;
      }

      if (this.hasLimitedView()) {
        this.mainTab = "students";
        this.activeTab = "";

        return;
      }

      if (query.goToGeoSection) {
        this.mainTab = "geo";
        this.activeTab = "";

        return;
      }

      if (
        !query.goToMessageSection &&
        !query.goToCallbackSection &&
        !query.goToContactUsSection &&
        !query.goToEmailsSection &&
        !query.goToSiteVisitSection &&
        !query.goToIvrCallSection &&
        !query.goToFaxesSection &&
        !query.goToCallsSection &&
        !query.goToRegistrationKollel &&
        !query.goToCouponsSection
      ) {
        this.mainTab = "payments";

        if (query.paymentPickupID) {
          this.activeTab = "pickup";
        } else {
          this.activeTab = "processed";
        }

        return;
      }

      if (query.goToCouponsSection) {
        this.mainTab = "payments";
        this.activeTab = "coupons";

        return;
      }

      if (query.goToRegistrationKollel) {
        this.mainTab = "registation";
      }

      if (this.goToCommunicationSection()) {
        this.mainTab = "communications";
        this.loadCommunicationCounts();

        if (query.goToMessageSection) {
          this.activeTab = "messages";
        }
        if (query.goToCallbackSection) {
          this.activeTab = "callback";
        }
        if (query.goToContactUsSection) {
          this.activeTab = "contactus";
        }
        if (query.goToEmailsSection) {
          this.activeTab = "emails";
        }
        if (query.goToSiteVisitSection) {
          this.activeTab = "sitevisits";
        }
        if (query.goToIvrCallSection) {
          this.activeTab = "ivrcalls";
        }
        if (query.goToFaxesSection) {
          this.activeTab = "faxes";
        }
        if (query.goToCallsSection) {
          this.activeTab = "calls";
        }
      }
    },
    transactionsLoaded(newValue, oldValue) {
      if (newValue) {
        this.paymentsToDisplay = this.payments.slice(0, 5);
        this.schedulesToDisplay = this.schedules.slice(0, 5);
      }
    },
  },
  computed: {
    allSelected: {
      get() {
        this.getTabList(this.activeTab).every((payment) => payment.selected);
      },
      set(select) {
        this.getTabList(this.activeTab).forEach(
          (payment) => (payment.selected = select)
        );
      },
    },
    paymentsPages() {
      return this.paymentsPagination.rowsPerPage
        ? Math.ceil(this.payments.length / this.paymentsPagination.rowsPerPage)
        : 0;
    },
    schedulePages() {
      return this.schedulePagination.rowsPerPage
        ? Math.ceil(this.schedules.length / this.schedulePagination.rowsPerPage)
        : 0;
    },
    showCampCouponsFirst() {
      const now = new Date().getTime();
      const campDeadline = this.campCouponDeadline;
      const matzoDeadline = this.matzoCouponDeadline;

      const campHasDeadline = !!campDeadline;
      const matzoHasDeadline = !!matzoDeadline;
      const campUnexpired = campHasDeadline && campDeadline >= now;
      const matzoUnexpired = matzoHasDeadline && matzoDeadline >= now;

      if (campUnexpired !== matzoUnexpired) {
        return campUnexpired;
      }

      if (
        campHasDeadline &&
        matzoHasDeadline &&
        campDeadline !== matzoDeadline
      ) {
        return campDeadline < matzoDeadline;
      }

      if (campHasDeadline !== matzoHasDeadline) {
        return campHasDeadline;
      }

      if (!this.campLatestCouponDate && !this.matzoLatestCouponDate) {
        return false;
      }

      if (this.campLatestCouponDate && !this.matzoLatestCouponDate) {
        return true;
      }

      if (!this.campLatestCouponDate && this.matzoLatestCouponDate) {
        return false;
      }

      return this.campLatestCouponDate > this.matzoLatestCouponDate;
    },
    anyCommCountLoading() {
      return (
        this.isCommCountLoading("contactus") ||
        this.isCommCountLoading("messages") ||
        this.isCommCountLoading("callback") ||
        this.isCommCountLoading("emails") ||
        this.isCommCountLoading("faxes") ||
        this.isCommCountLoading("calls") ||
        this.isCommCountLoading("sitevisits") ||
        this.isCommCountLoading("ivrcalls")
      );
    },
  },
  beforeDestroy() {
    this.firebaseRef.off();
  },
  created() {},
  methods: {
    setMatzoLatestCouponDate(value) {
      this.matzoLatestCouponDate = value || null;
    },
    setCampLatestCouponDate(value) {
      this.campLatestCouponDate = value || null;
    },
    setMatzoCouponDeadline(value) {
      this.matzoCouponDeadline = value || null;
    },
    setCampCouponDeadline(value) {
      this.campCouponDeadline = value || null;
    },
    goToCommunicationSection() {
      const query = this.$route.query;

      return (
        query.goToContactUsSection ||
        query.goToMessageSection ||
        query.goToCallbackSection ||
        query.goToEmailsSection ||
        query.goToSiteVisitSection ||
        query.goToIvrCallSection ||
        query.goToFaxesSection ||
        query.goToCallsSection
      );
    },
    openApplicationInfoSection() {
      this.mainTab = "registation";
      this.activeTab = "registation";

      const tryExpand = (attempts) => {
        const registationRef = this.$refs.registation;
        const registation = Array.isArray(registationRef)
          ? registationRef[0]
          : registationRef;
        if (registation && registation.expandApplicationInfo) {
          registation.expandApplicationInfo();
          return;
        }

        if (attempts < 10) {
          setTimeout(function() {
            tryExpand(attempts + 1);
          }, 50);
        }
      };

      this.$nextTick(function() {
        tryExpand(0);
      });
    },
    async loadSmsMessagesCount() {
      if (!this.account || !this.account.accountID) return;

      try {
        const response = await this.$http.get(
          "api/broadcast/GetAccountMessagesCount?accountID=" +
            this.account.accountID
        );
        this.smsMessagesCount = response || 0;
      } catch (e) {
        this.smsMessagesCount = 0;
      }

      this.commCountsLoaded.messages = true;
    },
    isCommCountLoading(name) {
      if (name === "contactus") {
        return !this.contactUsLoaded;
      }
      if (name === "callback") {
        return !this.callbackRequestsLoaded;
      }

      return !this.commCountsLoaded[name];
    },
    commTabLabel(label, name, count) {
      if (this.isCommCountLoading(name)) {
        return label + " ...";
      }

      return label + " (" + (count || 0) + ")";
    },
    getContactUsCount() {
      return (this.contactUsRequests || []).length;
    },
    getCallbackCount() {
      return (this.callbackRequests || []).length;
    },
    getEmailsCount() {
      return this.emailsCount || 0;
    },
    getSiteVisitsCount() {
      return (this.siteVisits || []).length;
    },
    getIvrCallsCount() {
      return (this.ivrCalls || []).length;
    },
    setPaymentsPagianation() {
      if (this.getPaymentsSkip() >= this.payments.length) return;

      const number =
        (this.paymentsPagination.page - 1) *
        this.paymentsPagination.rowsPerPage;

      this.paymentsToDisplay = this.payments.slice(
        number,
        number + this.paymentsPagination.rowsPerPage
      );
    },
    getPaymentsSkip() {
      const page = this.paymentsPagination.page - 1;

      let skip = page * this.paymentsPagination.rowsPerPage;

      if (skip >= this.payments.length) {
        skip = this.payments.length - this.paymentsPagination.rowsPerPage;
      }

      return skip;
    },
    setSchedulePagianation() {
      if (this.getSchedulesSkip() >= this.schedules.length) return;

      const number =
        (this.schedulePagination.page - 1) *
        this.schedulePagination.rowsPerPage;

      this.schedulesToDisplay = this.schedules.slice(
        number,
        number + this.schedulePagination.rowsPerPage
      );
    },
    getSchedulesSkip() {
      const page = this.schedulePagination.page - 1;

      let skip = page * this.schedulePagination.rowsPerPage;

      if (skip >= this.schedules.length) {
        skip = this.schedules.length - this.schedulePagination.rowsPerPage;
      }

      return skip;
    },
    getTabItems() {
      switch (this.mainTab) {
        case "payments":
          return ["processed", "scheduled", "rewards", "pickup", "coupons"];
        case "communications":
          return [
            "messages",
            "callback",
            "emails",
            "faxes",
            "calls",
            "sitevisits",
            "ivrcalls",
            "contactus",
          ];
        case "registation":
          return ["registation", "vm"];
      }
    },
    changeMainTab(value) {
      if (value == "payments") {
        this.activeTab = "processed";
      } else if (value == "communications") {
        this.activeTab = "messages";
        this.loadCommunicationCounts();
      } else if (value == "registation") {
        this.activeTab = "registation";
      }
    },
    onEmailsLoaded(count) {
      this.emailsCount = count || 0;
      this.commCountsLoaded.emails = true;
    },
    onFaxesLoaded(count) {
      this.faxesCount = count || 0;
      this.commCountsLoaded.faxes = true;
    },
    onBroadcastCallsLoaded(count) {
      this.broadcastCallsCount = count || 0;
      this.commCountsLoaded.calls = true;
    },
    async loadCommunicationCounts() {
      if (!this.account || !this.account.accountID) {
        return;
      }

      try {
        this.emailsCount = await this.$http.get(
          "api/emails/getCountForAccount?accountID=" + this.account.accountID
        );
      } catch (e) {
        this.emailsCount = 0;
      }
      this.commCountsLoaded.emails = true;

      try {
        this.faxesCount = await this.$http.get(
          "api/faxes/getCountForAccount?accountID=" + this.account.accountID
        );
      } catch (e) {
        this.faxesCount = 0;
      }
      this.commCountsLoaded.faxes = true;

      try {
        this.broadcastCallsCount = await this.$http.get(
          "api/broadcast/getCallsCountForAccount?accountID=" +
            this.account.accountID
        );
      } catch (e) {
        this.broadcastCallsCount = 0;
      }
      this.commCountsLoaded.calls = true;

      try {
        this.siteVisitsCount = await this.$http.get(
          "api/site/getCountForAccount?accountID=" + this.account.accountID
        );
      } catch (e) {
        this.siteVisitsCount = 0;
      }
      this.commCountsLoaded.sitevisits = true;

      try {
        this.ivrCallsCount = await this.$http.get(
          "api/iVRCalls/getCountForAccount?accountID=" + this.account.accountID
        );
      } catch (e) {
        this.ivrCallsCount = 0;
      }
      this.commCountsLoaded.ivrcalls = true;
    },
    changeTab(tab) {
      if (tab == "payments") {
        this.activeTab = "processed";
      }
      if (tab == "communications") {
        this.activeTab = "messages";
      }
    },
    hasLimitedView() {
      if (this.limitedView) return true;

      const roles = Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];

      return roles.includes("Limited Account View");
    },
    isAdmin() {
      const isAdmin = this.$store.getters["authentication/isAdmin"];

      if (!isAdmin || isAdmin == "false") return false;

      return true;
    },
    showGeo() {
      return !this.hasLimitedView();
    },
    firebaseSetup() {
      const firebaseConfig = {
        apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
        authDomain: "utaw.firebaseapp.com",
        databaseURL: "https://utaw.firebaseio.com",
        projectId: "project-683582246459980907",
        storageBucket: "project-683582246459980907.appspot.com",
        messagingSenderId: "193425158146",
        appId: "1:193425158146:web:f1ae134a803fb75832371b",
      };

      // Initialize Firebase
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }

      var database = firebase.database();
      var ref = firebase.database().ref("incoming-messages");

      const accountID = (this.account.accountID || "").trim();

      const query = ref
        .orderByChild("AccountID")
        .equalTo(accountID)
        .limitToLast(1);

      this.firebaseRef = query;

      this.firebaseRef.on(
        "value",
        (snapshot) => {
          if (snapshot.val()) {
            this.pendingMessagesCount = snapshot.val()[
              Object.keys(snapshot.val())
            ].PendingCount;
          }
        },
        function(error) {
          console.log("Error: " + error.code);
        }
      );
    },
    getTabList() {
      const tab = this.activeTab.substring(this.activeTab.lastIndexOf("-") + 1);

      switch (tab) {
        case "processed":
          return this.payments || [];
        case "scheduled":
          return this.schedules || [];
        case "messages":
        case "rewards":
        case "pickup":
        case "coupons":
        case "contactus":
        case "callback":
        case "sitevisits":
        case "ivrcalls":
        case "emails":
        case "faxes":
        case "calls":
          return [];
      }
    },
    async openLapidusDialog() {
      const transaction = await this.$http.get(
        "api/lapidusDayCamp/getTransaction?accountID=" + this.account.accountID
      );

      if (transaction) {
        this.lapidus.bungalow = transaction.bungalow;
        this.lapidus.quantity = transaction.quantity;
        this.lapidus.charge = transaction.charge;
        this.lapidus.id = transaction.id;
      }

      this.lapidus.lapidusDialog = true;
    },
    async saveLapidusCharge() {
      if (
        !this.$refs.lapidusBungalow.validate(true) ||
        !this.$refs.lapidusQuantity.validate(true) ||
        !this.$refs.lapidusCharge.validate(true)
      )
        return;

      try {
        this.processing = true;

        const today = moment().format("YYYY-MM-DD HH:mm:ss");
        const year = moment().format("YYYY");

        await this.$http.post("api/lapidusDayCamp/saveLapidusTransaction", {
          accountID: this.account.accountID,
          type: "Charge",
          year: year,
          date: today,
          byUser: this.$store.state.authentication.user,
          bungalow: this.lapidus.bungalow,
          quantity: this.lapidus.quantity,
          charge: this.lapidus.charge,
          id: this.lapidus.id,
          total: (this.lapidus.quantity || 0) * (this.lapidus.charge || 0),
        });

        this.processing = false;
        this.lapidus.lapidusDialog = false;
      } catch (e) {
        this.processing = false;
      }
    },
    openRescheduleDialog(schedule) {
      this.paymentToReschedule = schedule;
      this.rescheduleDialog = true;
    },
    async reschedule() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/payments/ReschedulePayment?scheduleDetailID=" +
            this.paymentToReschedule.scheduleDetailID
        );

        this.processing = false;
        this.rescheduleDialog = false;

        // const schedule = this.schedulesToDisplay.find(
        //     (s) => s.scheduleId == this.paymentToReschedule.scheduleID,
        // );

        // this.onExpended(schedule);

        this.reloadPage();
      } catch (e) {
        this.processing = false;
      }
    },
    emptyCardText() {
      const tab = this.activeTab.substring(this.activeTab.lastIndexOf("-") + 1);

      switch (tab) {
        case "processed":
          return "No Payments";
        case "scheduled":
          return "No Schedules";
      }
    },
    showActions() {
      return this.getTabList(this.activeTab).some(
        (payment) => payment.selected
      );
    },
    getAvailableActions() {
      return [
        {
          text: "Cancel Scheduled Payments",
          action: () => this.openEditScheduleDialog(),
        },
      ];
    },
    allowBulkSelection() {
      return false;
      // return (
      //     this.allPayments.filter(p => p.status == "SCHEDULED").length > 1
      // );
    },
    getSelectedPayments() {
      if (this.activeTab == "tabs-scheduled") {
        return this.getTabList(this.activeTab).filter(
          (s) => s.selected && s.source == "ONLINE"
        );
      }

      return this.getTabList(this.activeTab).filter(
        (s) => s.selected && s.status == "PROCESSED"
      );
    },
    allowEditingSchedule(schedule) {
      return schedule.pending > 0;
    },
    getPendingCallbackRequestsCount() {
      return (this.callbackRequests || []).filter((c) => c.status == "PENDING")
        .length;
    },
    async openEditScheduleDialog(schedule) {
      const scheduleDetails = schedule.scheduleDetails
        .filter((s) => s.status == "Scheduled")
        .map((detail) => {
          detail.datePickerMenu = false;
          detail.selected = false;
          detail.scheduleDetailId = detail.scheduleDetailID;
          detail.scheduleId = detail.scheduleID;

          detail.scheduleDate = new Date(detail.scheduleDate)
            .toISOString()
            .substr(0, 10);

          return detail;
        });

      this.scheduleToEdit = JSON.parse(JSON.stringify(schedule));
      this.scheduleToEdit.scheduleDetails = JSON.parse(
        JSON.stringify(scheduleDetails)
      );

      this.originalSchedule = JSON.parse(JSON.stringify(this.scheduleToEdit));

      this.editScheduleDialog = true;
    },
    closeEditScheduleDialog() {
      this.editScheduleDialog = false;
    },

    openConfirmActionDialog(payment) {
      this.confirmActionDialog = true;
    },
    async confirmAction() {
      this.processingAction = true;

      if (this.activeTab == "tabs-scheduled") {
        await this.cancelScheduledPayments();

        return this.reloadPage();
      }

      const payments = this.getTabList(this.activeTab).filter(
        (payment) => payment.selected && payment.status == "PROCESSED"
      );

      for (const payment of payments) {
        await this.voidPayment(payment);
      }

      this.reloadPage();
    },
    async voidPayment(payment) {
      await this.$http.post("api/payments/voidPayment", {
        params: {
          paymentID: payment.paymentID,
          amount: payment.amount.replace("$", ""),
          reason: "",
        },
      });
    },
    formatCurrency(amount) {
      return formatCurrency(amount);
    },
    getPaymentStatus(payment) {
      if (["ERROR", "PROCESSED", "DECLINED"].includes(payment.status))
        return payment.status;

      let statusDetails = "";

      if (payment.pending) {
        statusDetails += payment.pending + " SCHEDULED";
      }

      if (payment.processed) {
        statusDetails +=
          (statusDetails ? " / " : "") + payment.processed + " PROCESSED";
      }

      if (payment.canceled) {
        statusDetails +=
          (statusDetails ? " / " : "") + payment.canceled + " CANCELED";
      }

      if (payment.declined) {
        statusDetails +=
          (statusDetails ? " / " : "") + payment.declined + " DECLINED";
      }

      if (payment.error) {
        statusDetails +=
          (statusDetails ? " / " : "") + payment.error + " ERROR";
      }

      return statusDetails;
    },
    getPaymentDate(payment) {
      if (["ERROR", "PROCESSED", "DECLINED"].includes(payment.status))
        return this.formatTime(payment.date);

      return (
        moment(payment.startDate).format("L") +
        " - " +
        moment(payment.endDate).format("L")
      );
    },
    getStatusIcon(payment) {
      if (this.activeTab == "scheduled") {
        if (payment.pending) return "mdi-clock";
        if (payment.processed) return "mdi-check-circle";

        return "mdi-cancel";
      }

      switch (payment.status) {
        case "PROCESSED":
          return "mdi-check-circle";
        case "DECLINED":
          return "mdi-alert";
        case "ERROR":
          return "mdi-alert-circle";
        default:
          return "";
      }
    },
    getStatusIconColor(payment) {
      if (this.activeTab == "scheduled") {
        if (payment.pending) return "#fdb400";
        if (payment.processed) return "success";

        return "#aeb8bf";
      }

      switch (payment.status) {
        case "PROCESSED":
          return "success";
        case "DECLINED":
        case "ERROR":
          return "#f35123";
        default:
          return "#aeb8bf";
      }
    },
    viewSchedule(payment) {
      const schedule = this.schedules.find(
        (s) => s.scheduleId == payment.scheduleID
      );

      this.expandedSchedule = this.schedules.indexOf(schedule);

      this.expandedPayment = this.payments.indexOf(payment);

      this.onExpended(schedule);

      this.activeTab = "scheduled";
    },
    expandSchedule(scheduleID) {
      const schedule = this.schedules.find((s) => s.scheduleId == scheduleID);

      this.expandedSchedule = this.schedules.indexOf(schedule);

      this.onExpended(schedule);

      this.activeTab = "scheduled";
    },
    getPaymentProperties(payment) {
      return Object.keys(
        except(payment, "details", "refunds", "date", "amount")
      )
        .map((key) => {
          return {
            name: toTitleCase(key),
            value: payment[key],
          };
        })
        .filter((p) => p.value);
    },
    getScheduleProperties(schedule) {
      return Object.keys(
        except(
          schedule,
          "scheduleDetails",
          "amount",
          "amountProcessed",
          "processed"
        )
      )
        .map((key) => {
          const value = [
            "startDate",
            "dateCreated",
            "nextScheduleDate",
            "lastSuccessfulSchedule",
            "endDate",
          ].includes(key)
            ? this.formatTime(schedule[key])
            : schedule[key];

          return {
            name: toTitleCase(key),
            value: value,
          };
        })
        .filter((p) => p.value);
    },
    getPaymentDetails(payment) {
      return payment.details
        .split("|")
        .map((detail) => {
          const category =
            this.categories.get(detail.split(":")[0]) || detail.split(":")[0];
          const amount = detail.split(":")[1];

          return category + ": " + formatCurrency(amount);
        })
        .join(" | ");
    },
    getRefundDetails(payment) {
      if (!payment.refunds) return;

      return payment.refunds.split("|").map((detail) => {
        const date = this.formatTime(detail.split(",")[0]);
        const amount = detail.split(",")[1];

        return {
          date,
          amount,
        };
      });
    },
    formatTime(date) {
      if (!date) return "";

      return moment(date).format("MM/DD/YYYY h:mm:ss A");
    },
    canReverse(payment) {
      return (
        payment.status == "PROCESSED" &&
        !["Refund", "Void"].includes(payment.transactionType)
      );
    },
    reversePayment(payment) {
      this.paymentToReverse = JSON.parse(JSON.stringify(payment));

      this.paymentToReverse.details = payment.details
        .split("|")
        .map((detail) => {
          const category =
            this.categories.get(detail.split(":")[0]) || detail.split(":")[0];
          const amount = detail.split(":")[1];

          if (!+amount) return false;

          return {
            category,
            amount,
            maxAmount: +amount,
          };
        })
        .filter(Boolean);

      this.reversePaymentDialog = true;
    },
    closeReversePaymentDialog() {
      this.reversePaymentDialog = false;
    },
    closeNewPaymentDialog() {
      this.newPaymentDialog = false;
    },
    async onExpended(schedule) {
      schedule.loading = true;

      const details = await this.$http.get(
        "api/schedules/getScheduleDetails?scheduleID=" + schedule.scheduleId
      );

      schedule.loading = false;

      schedule.scheduleDetails = details.map((detail) => {
        detail.cardInfo = detail.cardType + " - " + detail.cardNumLast5;

        return detail;
      });
    },
  },
};
</script>
<style>
.expansion-panel-margin .v-expansion-panel__header {
  margin-top: 5px;
  margin-bottom: 5px;
}
.schedule-list .vgt-table {
  border: 1px solid #ddd;
} /*
.schedule-list th {
    background-color: #4caf50 !important;
    color: white;
}*/
.account-transactions-tab .v-tabs__slider-wrapper {
  left: 226px !important;
}
.account-transactions-tab .v-tabs__container {
  margin-bottom: 6px !important;
}
.selected-tab {
  color: rgb(76, 175, 80) !important;
  border-bottom: 1px solid rgb(76, 175, 80) !important;
}
.selected-tab-icon {
  color: rgb(76, 175, 80) !important;
}
.comm-tab-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.comm-tab-icon-wrap .v-icon {
  display: inline-flex !important;
  margin-bottom: 0 !important;
}
.account-transactions-subtab .v-tabs__item .comm-pending-count,
.comm-pending-count {
  color: #c47b00 !important;
  font-weight: 700;
  margin-left: 4px;
  line-height: 1;
  opacity: 1 !important;
}
.account-transactions-subtab .v-tabs__item.selected-tab .comm-pending-count,
.account-transactions-subtab .v-tabs__item--active .comm-pending-count {
  color: #fdb400 !important;
}
.account-transactions-subtab .v-tabs__container--icons-and-text {
  height: 61px !important;
}
.communications-subtabs .v-tabs__icon {
  display: none !important;
}
.communications-subtabs .v-tabs__bar,
.communications-subtabs .v-tabs__wrapper {
  overflow: visible !important;
  contain: none !important;
  height: auto !important;
}
.communications-subtabs .v-tabs__container,
.communications-subtabs .v-tabs__container--icons-and-text {
  height: 62px !important;
  flex: 1 1 100% !important;
  width: 100%;
  max-width: 100%;
  flex-wrap: nowrap !important;
  overflow: visible !important;
  transform: none !important;
  white-space: normal !important;
}
.comm-subtab-group {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
}
.comm-subtab-group .v-tabs__div {
  flex: 1 1 0 !important;
  min-width: 0 !important;
  max-width: none !important;
  height: 62px;
}
.comm-subtab-group .v-tabs__item {
  width: 100%;
  min-width: 0 !important;
  max-width: none !important;
  height: 62px;
  padding: 8px 4px 5px !important;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  justify-content: flex-end;
}
.comm-subtab-group .v-tabs__item .v-icon {
  font-size: 17px !important;
  margin-bottom: 3px !important;
}
.comm-subtab-group .comm-tabs-loading {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.comm-tabs-loading {
  margin: 0 !important;
}
.coupon-types-container {
  padding-top: 18px !important;
  padding-bottom: 6px;
}
.coupon-type-header-wrap {
  margin-bottom: 6px;
  padding: 4px 2px 0;
}
.coupon-type-header-wrap--spaced {
  margin-top: 28px;
}
.coupon-type-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 8px;
}
.coupon-type-header-left {
  display: flex;
  align-items: center;
  gap: 6px;
}
.coupon-type-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #374151;
}
.coupon-type-icon--camp {
  color: #2e7d32;
}
.coupon-type-icon--matzo {
  color: #d97706;
}
.coupon-type-icon--disc {
  color: #1565c0;
}
.coupon-type-pill {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border-radius: 999px;
  padding: 2px 9px;
}
.coupon-type-pill--camp {
  color: #166534;
  background: #dcfce7;
}
.coupon-type-pill--matzo {
  color: #92400e;
  background: #fef3c7;
}
.coupon-type-pill--disc {
  color: #1e40af;
  background: #dbeafe;
}
</style>
